var _defs, _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _polyline, _polyline2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgManage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 63.74 61.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #1d47b1;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.85px;\n      }\n\n      .cls-2 {\n        fill: #d7e8f0;\n        stroke: #d7e8f0;\n        stroke-width: 2px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m35.47,15.25c3.99-5.88,15.85-3.29,18.6,4.99,2.76,8.29-4.34,11.2-5.71,14.57-1.92,4.73.53,12.4-7.67,14.13-8.38,1.76-7.74-5.77-14.67-4.64-23.2,3.77-20.31-27.53-5.18-25.08,6.48.49,9.86,3.05,14.63-3.97Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m18.21,32.09h0c3.77,0,6.83,3.06,6.83,6.83v10.22h-11.04c-1.44,0-2.62-1.17-2.62-2.62v-7.6c0-3.77,3.06-6.83,6.83-6.83Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m31.87,24.37h0c3.77,0,6.83,3.06,6.83,6.83v17.94h-13.66v-17.94c0-3.77,3.06-6.83,6.83-6.83Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m45.53,32.09h0c3.77,0,6.83,3.06,6.83,6.83v10.22h-13.66v-10.22c0-3.77,3.06-6.83,6.83-6.83Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 32.02,
    cy: 16.53,
    r: 4.71
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 18.21,
    cy: 24.69,
    r: 4.38
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 45.53,
    cy: 24.8,
    r: 4.5
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "29.48 24.8 31.05 27.71 33.01 27.71 34.27 24.8"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "31.05 27.71 30.02 39.05 32.02 40.95 33.73 38.95 33.01 27.71"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManage);
export default __webpack_public_path__ + "static/media/manage.baaf27330e71f746f49f22b769f34263.svg";
export { ForwardRef as ReactComponent };